// extracted by mini-css-extract-plugin
module.exports = {"healthProfessionalControlButtons":"HealthProfessionalControlButtons_healthProfessionalControlButtons__19YzS"};